import "./App.css";
import "./index.css";
import "./appComponents/main.scss";
import Root from "./appComponents/Root";
import AppPortalContainer from "./providers/AppPortalContainer";

function App() {
  return (
    <AppPortalContainer className="App">
      <Root />
    </AppPortalContainer>
  );
}

export default App;
